import { render, staticRenderFns } from "./RelatorioComparativoNotas.vue?vue&type=template&id=2a4c97dc"
import script from "./RelatorioComparativoNotas.vue?vue&type=script&lang=js"
export * from "./RelatorioComparativoNotas.vue?vue&type=script&lang=js"
import style0 from "./RelatorioComparativoNotas.vue?vue&type=style&index=0&id=2a4c97dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports